import fingerprintjs2 from 'fingerprintjs2';
import {queryParams} from '../../../../utils/queryParams';

let hash = null;
let discountId = null;

const initPages = [
  '/checkout',
  '/splash',
];


export default {

  created(){
    if (document.readyState !== 'complete') {
      document.addEventListener('readystatechange', () =>  {
        if (document.readyState === 'complete') {
          if (!queryParams()['3ds']) {
            setTimeout(this.fingerprint_apply_discount, 1000);
          }
        }
      });
    } else {
      if (!queryParams()['3ds']) {
        setTimeout(this.fingerprint_apply_discount, 1000);
      }
    }
  },

  methods: {

    fingerprint_calculate() {
      if (hash) {
        return Promise.resolve(hash);
      }

      return fingerprintjs2.getPromise({fonts: {extendedJsFonts: true} }).then(components => {
        const values = components.map(component => component.value);
        hash = fingerprintjs2.x64hash128(values.join(''), 31);

        return hash
      });
    },

    dataFor3DSChallenge() {
      return {
        lang: navigator.language || navigator.languages[0],
        color: window.screen.colorDepth,
        height: window.screen.height,
        width: window.screen.width,
        tz: new Date().getTimezoneOffset(),
        java: navigator.javaEnabled(),
      };
    },

    fingerprint_apply_discount() {
      for (let page of initPages) {
        if (location.pathname.startsWith(page)) {
          return Promise.resolve()
            .then(() => {
              return this.fingerprint_calculate();
            })
            .then(hash => {
              const bdata = this.dataFor3DSChallenge();

              return fetch('/apply-discount', {
                method: 'post',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({
                  f: hash,
                  url: location.href,
                  bdata: bdata,
                }),
              });
            })
            .then(response => response.text())
            .then(text => {
              discountId = text;
            })
            .catch(err => {

            });
        }
      }
    },

    log_unit_quantity(qty) {
      if (!discountId) {
        return;
      }

      fetch('/units-quantity/' + discountId, {
        method: 'post',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          qty: qty
        }),
      })
    }

  },

};

